import type { AreaCatalog } from '../area';
import type { accountErrors as en } from '../en/accountErrors';

export const accountErrors = {
  'accountErrors.deletion.ownFromAccountPage': 'Lösche dein eigenes Konto auf deiner Kontoseite.',
  'accountErrors.deletion.alreadyDeleted': 'Dieses Konto ist schon gelöscht.',
  'accountErrors.deletion.lastOperator':
    'Die letzte betreibende Person kann nicht gelöscht werden. Mach zuerst jemand anderen zur betreibenden Person.',
  'accountErrors.deletion.onlyOwnerSelf':
    'Du bist die einzige verwaltende Person von {names}. Mach zuerst ein anderes Mitglied zur verwaltenden Person.',
  'accountErrors.deletion.onlyOwnerOther':
    'Diese Person ist die einzige verwaltende Person von {names}. Zuerst braucht es eine weitere verwaltende Person.',
  'accountErrors.deletion.scrubbed':
    'Dieses Konto wurde bereinigt. Es lässt sich nicht wiederherstellen.',
  'accountErrors.deletion.notDeleted': 'Dieses Konto ist nicht gelöscht.',
  'accountErrors.label.required': 'Eine Bezeichnung ist nötig.',
  'accountErrors.link.labelTooLong': 'Bezeichnung: höchstens {max} Zeichen.',
  'accountErrors.link.uses': 'Nutzungen: eine ganze Zahl von 1 bis {max}.',
  'accountErrors.link.expiry': 'Ablauf: eine ganze Zahl von Tagen von 1 bis {max}.',
  'accountErrors.link.groupRole': 'Rolle in der Gruppe: eine von {roles}.',
  'accountErrors.keyScope.missing':
    'Ein Agentenschlüssel sagt, was er darf und wo. Volle Befugnis ist eine eigene Wahl.',
  'accountErrors.keyScope.unreadable': 'Der Umfang des Agentenschlüssels ist nicht lesbar.',
  'accountErrors.keyScope.access':
    'Ein Agentenschlüssel darf sehen, sehen und ändern, oder sehen, ändern und teilen.',
  'accountErrors.keyScope.rootIds':
    'Die Aufgaben, die ein Agentenschlüssel erreicht, werden mit ihren IDs angegeben.',
  'accountErrors.keyScope.noRoots':
    'Wähle mindestens eine Aufgabe, oder keine, um alles zu erreichen, was du erreichst.',
  'accountErrors.keyScope.tooManyRoots':
    'Ein Agentenschlüssel erreicht höchstens {max} Aufgaben und was darunter liegt.',
  'accountErrors.keyScope.where':
    "Ein Agentenschlüssel sagt, wo er handelt: 'everything', oder einige Gruppen und deine eigenen Aufgaben.",
  'accountErrors.keyScope.own':
    'Ob ein Agentenschlüssel deine eigenen Aufgaben erreicht, ist ja oder nein.',
  'accountErrors.keyScope.groupIds':
    'Die Gruppen, die ein Agentenschlüssel erreicht, werden mit ihren IDs angegeben.',
  'accountErrors.keyScope.noGroups': 'Wähle mindestens eine Gruppe oder deine eigenen Aufgaben.',
  'accountErrors.keyScope.tooManyGroups': 'Ein Agentenschlüssel erreicht höchstens {max} Gruppen.',
  'accountErrors.noSuch.item': 'Diese Aufgabe gibt es nicht.',
  'accountErrors.noSuch.group': 'Diese Gruppe gibt es nicht.',
  'accountErrors.noSuch.account': 'Dieses Konto gibt es nicht.',
  'accountErrors.noSuch.app': 'Diese App gibt es nicht.',
  'accountErrors.noSuch.key': 'Diesen Agentenschlüssel gibt es nicht.',
  'accountErrors.noSuch.link': 'Diesen Link gibt es nicht.',
  'accountErrors.noSuch.contact': 'Diesen Kontakt gibt es nicht.',
  'accountErrors.account.deleted': 'Dieses Konto ist gelöscht.',
  'accountErrors.deletion.selfOnly': 'Nur die Person selbst kann ihr Konto löschen.',
  'accountErrors.deletion.inPerson':
    'Betreibende löschen ein Konto selbst, nie über einen Agentenschlüssel.',
  'accountErrors.operator.only': 'Nur für Betreibende.',
  'accountErrors.operator.removeSelf':
    'Du kannst dich nicht selbst als betreibende Person entfernen. Frag eine andere betreibende Person.',
  'accountErrors.operator.removeLast': 'Die letzte betreibende Person kann nicht entfernt werden.',
  'accountErrors.link.notValid': 'Dieser Link ist nicht gültig.',
  'accountErrors.link.seatOwnerOnly':
    'Nur Verwaltende der Gruppe können Neue in die Gruppe aufnehmen.',
  'accountErrors.invite.notValid': 'Diese Einladung ist nicht mehr gültig.',
  'accountErrors.invite.badEmail': 'Das sieht nicht nach einer E-Mail-Adresse aus.',
  'accountErrors.invite.addressBarred': 'Diese Adresse kann nicht eingeladen werden.',
  'accountErrors.invite.badLifetime': 'Ungültige Gültigkeitsdauer der Einladung.',
  'accountErrors.invite.rateLimited':
    'Zu viele Einladungen in letzter Zeit. Warte eine Weile, bevor du weitere Personen einlädst.',
  'accountErrors.invite.notFound': 'Einladung nicht gefunden.',
  'accountErrors.invite.revokeForbidden':
    'Nur wer eingeladen hat oder die Aufgabe verwaltet, kann eine Einladung widerrufen.',
  'accountErrors.invite.notPending': 'Die Einladung ist nicht ausstehend.',
  'accountErrors.invite.personOnly': 'Nur eine Person kann eine Einladung annehmen.',
  'accountErrors.key.mintPersonOnly': 'Nur eine Person kann einen Agentenschlüssel erstellen.',
  'accountErrors.key.machineId':
    'Maschinen-ID: Kleinbuchstaben, Ziffern und Bindestriche, 2 bis 32 Zeichen.',
  'accountErrors.key.liveExists':
    'Für „{machineId}“ gibt es schon einen gültigen Agentenschlüssel. Widerrufe ihn zuerst.',
  'accountErrors.key.revokePersonOnly': 'Nur eine Person kann einen Agentenschlüssel widerrufen.',
  'accountErrors.app.allowPersonOnly': 'Nur eine Person kann eine App erlauben.',
  'accountErrors.app.removePersonOnly': 'Nur eine Person kann eine App entfernen.',
  'accountErrors.contact.personOnly': 'Nur eine Person hat Kontakte.',
  'accountErrors.contact.rateLimited':
    'Zu viele Kontaktanfragen in letzter Zeit. Warte eine Weile, bevor du weitere sendest.',
  'accountErrors.contact.identifierNeeded': 'Eine Kennung oder eine Adresse ist nötig.',
  'accountErrors.contact.self': 'Das bist du.',
  'accountErrors.contact.noRequest': 'Keine Anfrage zum Annehmen.',
  'accountErrors.password.tooShort': 'Ein Passwort braucht mindestens {min} Zeichen.',
  'accountErrors.password.alreadySet':
    'Dieses Konto hat schon ein Passwort. Ändere es mit deinem aktuellen.',
  'accountErrors.address.personOnly': 'Nur eine Person hat eine Adresse.',
  'accountErrors.address.invalid': 'Das ist keine Adresse.',
  'accountErrors.address.unchanged': 'Das ist schon deine Adresse.',
  'accountErrors.address.alreadyVerified': 'Diese Adresse ist schon bestätigt.',
  'accountErrors.push.unconfigured': 'Diese Instanz kann keine Benachrichtigungen senden.',
  'accountErrors.push.badSubscription': 'Dieses Abonnement ist nicht nutzbar.',
  'accountErrors.push.noDevice': 'Es wurde kein Gerät angegeben.',
  'accountErrors.deletion.personOnly': 'Nur eine Person hat ein Konto.',
  'accountErrors.deletion.addressMismatch': 'Das ist nicht die Adresse dieses Kontos.',
  'accountErrors.link.joinPersonOnly': 'Nur eine Person kann beitreten.',
  'accountErrors.agent.unauthorized':
    'Nicht angemeldet. Sende Authorization: Bearer <Agentenschlüssel>, oder verbinde dich über OAuth (die 401-Antwort nennt, wo). Ein widerrufener Agentenschlüssel oder eine entfernte Verbindung wirkt sofort nicht mehr.',
  'accountErrors.agent.bodyNotJson': 'Der Inhalt ist kein JSON.',
  'accountErrors.agent.bodyTooLarge': 'Der Inhalt ist größer als 2 MiB.',
} as const satisfies AreaCatalog<typeof en>;
